// Client-side cadences and limits of the notification center (§3-bis.5).
// Hooks and components read these; they never carry their own literals.

// Unread-count poll while the realtime connection is down (§11.2). While
// connected there is no polling at all.
export const NOTIFICATIONS_FALLBACK_POLL_MS = 30_000

// Reconnect after the server refused the connection (an expired or used
// cable ticket): exponential from the base, capped, with jitter so a
// deploy does not reconnect every browser in the same second.
export const CABLE_RECONNECT_BASE_MS = 1_000
export const CABLE_RECONNECT_MAX_MS = 60_000
export const CABLE_RECONNECT_JITTER = 0.3

// Cards per page of /notifications. The backend caps it (INBOX_MAX_PAGE_SIZE).
export const NOTIFICATIONS_PAGE_SIZE = 25

// Search box: longer input is truncated before it reaches the API.
export const NOTIFICATIONS_MAX_QUERY_LENGTH = 200
export const NOTIFICATIONS_SEARCH_DEBOUNCE_MS = 300

// How long the arrival toast stays; arrivals within it update the same toast.
export const NOTIFICATIONS_TOAST_DURATION_MS = 6_000

// Largest number the badge prints; above it, "99+".
export const NOTIFICATIONS_BADGE_MAX = 99
